var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "emailConsultItem", staticClass: "email-preview" }, [
    _c("div", { staticClass: "email-preview__header" }, [
      _c(
        "div",
        { staticClass: "email-preview__address-details" },
        [
          _c("CompassAvatar", {
            attrs: { size: "small", initials: _vm.senderInitials }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "email-preview__address-details-wrapper" }, [
            _c("div", { staticClass: "email-preview__sender" }, [
              _c(
                "div",
                {
                  staticClass:
                    "email-preview__sender-name typographies-paragraph-medium-semibold"
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.email.from.name) +
                      "\n                    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "email-preview__sender-email typographies-paragraph-small-regular"
                },
                [
                  _vm._v(
                    "\n                        (" +
                      _vm._s(_vm.email.from.email) +
                      ")\n                    "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "email-preview__recipients" }, [
              _c("div", { staticClass: "email-preview__recipients-label" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t.__("email.EmailConsultPanelItem.to")) +
                    ":\n                    "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "email-preview__recipients-list" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.formattedRecipients) +
                    "\n                    "
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "email-preview__extra-information" }, [
        _c("div", [
          _c(
            "div",
            {
              staticClass:
                "email-preview__sent-date typographies-paragraph-small-regular"
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.formattedSentDate) +
                  "\n                "
              )
            ]
          ),
          _vm._v(" "),
          _vm.attachmentCount > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "email-preview__attachments-count typographies-paragraph-small-semibold"
                },
                [
                  _c("CompassIcon", {
                    attrs: { size: "small", icon: "attachment" }
                  }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.formattedAttachmentCount) +
                      "\n                "
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "email-preview__content typographies-paragraph-medium-regular"
      },
      [
        _vm.thread.length && _vm.thread[0].linked_object
          ? _c("EmailRelatedObject", {
              attrs: { object: _vm.thread[0].linked_object }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "email-preview__content-text",
          class: _vm.editorClass,
          domProps: {
            innerHTML: _vm._s(_vm.addBrToEmptyPragraphs(_vm.getContentEmail))
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.attachmentCount > 0
      ? _c("div", { staticClass: "email-preview__attachments" }, [
          _c("div", { staticClass: "email-preview__attachments-summary" }, [
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-semibold" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.formattedAttachmentCount) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "email-preview__attachments-weight typographies-paragraph-medium-regular"
              },
              [
                _vm._v(
                  "(" +
                    _vm._s(_vm.formatBytes(_vm.attachmentsSize)) +
                    " au total)"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "email-preview__attachments-list" },
            _vm._l(_vm.email.attachments, function(attachment) {
              return _c("EmailAttachmentLink", {
                key: attachment.id,
                attrs: { file: attachment }
              })
            }),
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }